import { MEAL_LABELS, mealTypeForNow } from './format';

// Còn lại = Mục tiêu − Đã ăn + Vận động: exercise adds to the day's budget. The ring shows Đã ăn ÷ Mục tiêu,
// and the only warning state is going over (Còn lại below zero).
export const calorieSummary = (totals, goal) => {
  const eaten = totals?.calories_in ?? 0;
  const burned = totals?.calories_out ?? 0;
  if (!goal) return { goal: null, eaten, burned, left: null, pct: 0, over: false };
  const left = goal - eaten + burned;
  return { goal, eaten, burned, left, pct: Math.round((eaten / goal) * 100), over: left < 0 };
};

// Protein is a minimum to reach, not a cap.
export const proteinSummary = (totals, goal) => {
  const value = totals?.protein_g ?? 0;
  if (!goal) return { value, goal: null, missing: null, met: false, pct: 0 };
  const missing = Math.max(0, Math.round(goal - value));
  return { value, goal, missing, met: missing === 0, pct: Math.round((value / goal) * 100) };
};

export const isLogged = (day) => !!day && (day.meals.length > 0 || day.activities.length > 0);

// The single most useful next step for today: the meal due now if it isn't logged yet (snacks don't
// count), else the protein gap, else a well-done message.
export const nextAction = (day, goals, now = new Date()) => {
  const type = mealTypeForNow(now);
  const calories = calorieSummary(day?.totals, goals.calories);
  const protein = proteinSummary(day?.totals, day?.protein_goal);
  // Late at night nothing is due; the day's targets can wait until morning.
  if (now.getHours() < 5) return { kind: 'night', title: 'Khuya rồi, nghỉ ngơi nhé', calories, protein };
  const due = type !== 'snack' && !day?.meals.some((m) => m.meal_type === type);
  if (due) return { kind: 'meal', mealType: type, title: `${MEAL_LABELS[type]} chưa ghi`, calories, protein };
  if (protein.missing > 0) return { kind: 'protein', title: `Còn thiếu ${protein.missing} g đạm`, calories, protein };
  return { kind: 'done', title: 'Hôm nay bạn làm tốt lắm', calories, protein };
};

// The Home mascot's mood from today's protein: 'done' once the goal is reached, 'hungry' when well behind
// where the day should be by now (eating is expected from 7:00 to 21:00), otherwise 'ok'. Mornings are
// never "hungry".
export const mascotMood = (day, now = new Date()) => {
  const protein = proteinSummary(day?.totals, day?.protein_goal);
  if (!protein.goal) return 'ok';
  if (protein.met) return 'done';
  const hours = now.getHours() + now.getMinutes() / 60;
  const expected = Math.min(1, Math.max(0, (hours - 7) / 14));
  return expected >= 0.25 && protein.pct / 100 < expected * 0.7 ? 'hungry' : 'ok';
};
